export const config = {
    apiKey: "AIzaSyCxPnvj1GouSd_cLvlC43vVXSLgTD-M_2I",
    authDomain: "hrceramics-ff4ff.firebaseapp.com",
    databaseURL: "https://hrceramics-ff4ff.firebaseio.com",
    projectId: "hrceramics-ff4ff",
    storageBucket: "hrceramics-ff4ff.appspot.com",
    messagingSenderId: "893575855864",
    appId: "1:893575855864:web:1becc072e6a0a111eb850d",
    measurementId: "G-NHYFTGN0DD"
  };